import { Row } from "@components/Layout";
import { DropdownMenu } from "@kobalte/core";
import { FaRegularTrashCan } from "solid-icons/fa";
import { styled } from "solid-styled-components";

export const SlotWrapper = styled(Row)`
  background: ${({ theme }) => theme?.tracklist.trackEven};
  border-radius: 16px;
`;

export const DropdownArrow = styled(DropdownMenu.Icon)`
  transition: all 0.2s;
  &:is([data-expanded]) {
    rotate: 180deg;
  }
`;

export const DeleteIcon = styled(FaRegularTrashCan)<{ disabled?: boolean }>`
  cursor: pointer;
  ${({ disabled }) => (disabled ? "opacity: .5; cursor: not-allowed;" : "")}
`;
